import React from 'react';

const TagFilter = ({ selectedTags, setSelectedTags, availableTags }) => {
  // Remove duplicate tags based on their ID
  const uniqueTags = Array.from(
    new Map(availableTags.map(tag => [tag.id, tag])).values()
  );

  const handleTagClick = (tagId) => {
    if (selectedTags.includes(tagId)) {
      setSelectedTags(selectedTags.filter(id => id !== tagId));
    } else {
      setSelectedTags([...selectedTags, tagId]);
    }
  };

  return (
    <div className="w-full max-w-6xl mx-auto mb-8 px-4">
      <div className="flex flex-wrap gap-3 justify-center">
        {uniqueTags.map((tag) => (
          <button
            key={tag.id}
            onClick={() => handleTagClick(tag.id)}
            className={`px-4 py-2 rounded-full text-sm font-medium 
              transition-all duration-300 backdrop-blur-sm
              ${selectedTags.includes(tag.id)
                ? 'bg-white/90 text-zinc-900 shadow-lg hover:bg-white'
                : 'bg-zinc-800/90 text-white/70 border border-white/10 hover:bg-zinc-800/95 hover:text-white'
              }`}
          >
            {tag.name}
          </button>
        ))}
      </div>
    </div>
  );
};

export default TagFilter;
